"use client"

import { useState } from "react"
import { useRouter, useParams } from "next/navigation"
import { useAuth } from "@/hooks/use-auth"
import { Button } from "@/components/ui/button"
import { api } from "@/lib/api-client"

type Status = "idle" | "loading" | "error"

export function DevLogin() {
  const { locale } = useParams<{ locale: string }>()
  const router = useRouter()
  const { refreshUser } = useAuth()
  const [status, setStatus] = useState<Status>("idle")
  const [error, setError] = useState("")

  if (typeof window !== "undefined" && window.location.hostname !== "localhost" && !window.location.hostname.startsWith("127.")) {
    return null
  }

  const handleLogin = async (email: string) => {
    setStatus("loading")
    setError("")
    try {
      const res = await api.post("/api/v1/auth/dev-login", { email })
      if (!res.ok) {
        const text = await res.text()
        let msg = text
        try { msg = JSON.parse(text).message || text } catch { /* use raw text */ }
        throw new Error(`${res.status}: ${msg}`)
      }
      const data = await res.json()
      api.setTokens(data.access_token, data.refresh_token)
      await refreshUser()
      router.push(`/${locale}/dashboard`)
    } catch (e) {
      setError(e instanceof Error ? e.message : "Login failed")
      setStatus("idle")
    }
  }

  return (
    <div className="space-y-2">
      <div className="relative py-1">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t border-hairline-dark" />
        </div>
        <div className="relative flex justify-center">
          <span className="bg-surface-card-dark px-3 text-xs text-muted">dev</span>
        </div>
      </div>

      <div className="flex gap-2">
        <Button
          variant="secondary"
          size="sm"
          className="flex-1 text-xs"
          disabled={status === "loading"}
          onClick={() => handleLogin("admin@dev.local")}
        >
          Admin
        </Button>
        <Button
          variant="secondary"
          size="sm"
          className="flex-1 text-xs"
          disabled={status === "loading"}
          onClick={() => handleLogin("user@dev.local")}
        >
          User
        </Button>
      </div>

      {error && <p className="text-xs text-trading-down text-center">{error}</p>}
    </div>
  )
}
